<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->

<div class="work-schedule-header">
	<div class="work-heading" [ngClass]="{ disabled: isDisabled }">{{ appStrings.WORK_SCHEDULE }}</div>
	<div class="reset-link" automationId="resetAllLink" *ngIf="!isDisabled">
		<a (click)="resetAll()">{{ appStrings.RESET_ALL }}</a>
	</div>
</div>

<tp-day-chip-list
	[dayChips]="scheduleChips$"
	[disabled]="isDisabled"
	[themeType]="'schedule'"
	(chipClick)="selectWorkDay($event)"
></tp-day-chip-list>

<div class="schedule-inputs" *ngIf="selectedChipId">
	<mat-form-field class="start-time time-input">
		<mat-label>{{ appStrings.START_TIME }}</mat-label>
		<input matInput automationId="scheduleStartTime" (blur)="onTouched()" />
		<mat-icon matSuffix>alarm</mat-icon>
	</mat-form-field>

	<mat-form-field class="finish-time time-input">
		<mat-label>{{ appStrings.FINISH_TIME }}</mat-label>
		<input matInput automationId="scheduleFinishTime" (blur)="onTouched()" />
		<mat-icon matSuffix>alarm</mat-icon>
	</mat-form-field>

	<div class="clear-link">
		<a (click)="clear()">{{ appStrings.CLEAR }}</a>
	</div>
</div>
